import {
    FORMEDIT_GET_FORMSUBMIT_LIST_BEGIN,
    FORMEDIT_GET_FORMSUBMIT_LIST_SUCCESS,
    FORMEDIT_GET_FORMSUBMIT_LIST_FAILURE,
    FORMEDIT_GET_FORMSUBMIT_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getFormSubmitList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: FORMEDIT_GET_FORMSUBMIT_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'post',
            url:'/api/b/formSubmit/list',
            data:params,
          }).then( data => {
              dispatch({
                  type: FORMEDIT_GET_FORMSUBMIT_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: FORMEDIT_GET_FORMSUBMIT_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetFormSubmitListError() {
    return {
      type: FORMEDIT_GET_FORMSUBMIT_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case FORMEDIT_GET_FORMSUBMIT_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getFormSubmitListPending: true,
          getFormSubmitListError: null,
        };
  
      case FORMEDIT_GET_FORMSUBMIT_LIST_SUCCESS:
        // The request is success
  
        const byId = {};
        const items = [];
        action.data.list.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          formSubmitById:byId,
          formSubmitList:items,
          formSubmitPage: action.data.page,
          formSubmitSize: action.data.size,
          formSubmitTotal: action.data.count,
          getFormSubmitListPending: false,
          getFormSubmitListError: null,
        };
  
      case FORMEDIT_GET_FORMSUBMIT_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getFormSubmitListPending: false,
          getFormSubmitListError: action.data.error,
        };
  
      case FORMEDIT_GET_FORMSUBMIT_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getFormSubmitListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/formedit/redux/getFormSubmitList.js